<template>
  <div> 
      <component v-if="currentView!='' && showpage" :is="currentView" :key="currentView" :valuestyle="valuestyle"></component>
      <div v-if="!showpage" style="position: absolute;background: #fff;font-size: 16px;">
        {{showtext}}……
      </div>
  </div>    
</template>

<script>
import { defineAsyncComponent } from 'vue';
export default {
  data() {
    return {
      currentView: '',
      showtext:'加载中',
      showpage:false,
      clientWidth: document.documentElement.clientWidth, 
      zoomValue:1, 
      valuestyle:''     
    }
  },
  created() {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const currentUrl = `${protocol}//${host}`; 
    this.$request.setBaseURL(currentUrl )   
    this.getstyle()
  },
  components: {
    home1: defineAsyncComponent(() => import('./views/style1/home.vue')),
    home2: defineAsyncComponent(() => import('./views/style2/home.vue')),
    home3: defineAsyncComponent(() => import('./views/style3/home.vue')),
    home4: defineAsyncComponent(() => import('./views/style4/home.vue')),
    home5: defineAsyncComponent(() => import('./views/style5/home.vue')),
    home6: defineAsyncComponent(() => import('./views/style6/home.vue')),
    home7: defineAsyncComponent(() => import('./views/style7/home.vue')),
    home8: defineAsyncComponent(() => import('./views/style8/home.vue')),
    home9: defineAsyncComponent(() => import('./views/style9/home.vue')),
    home10: defineAsyncComponent(() => import('./views/style10/home.vue')),
    home11: defineAsyncComponent(() => import('./views/style11/home.vue')),
    home12: defineAsyncComponent(() => import('./views/style12/home.vue')),
    home13: defineAsyncComponent(() => import('./views/style13/home.vue')),
  },
  mounted() {
  
  },
  methods: {

    getstyle(){
        this.$request.postData('/linestyle',{www:window.location.href}).then(response => {
          if(response.code==200){          
             this.$store.commit('setValue',response.data.color)
             this.$store.commit('setcompanyId',response.data.id)
             this.valuestyle=  response.data 
             this.currentView = 'home' + response.data.color   
             this.showpage=true
          }else{
            this.showtext="网络连接失败"
            this.showpage=false
            this.$message.error(response.msg);
          }

        }).catch(error => {
          this.showtext="网络连接失败"
          this.showpage=false
        });        
    }
  }

}
</script>

